export default __webpack_public_path__ + "static/media/score_bar_left_left.9e878568.png";